(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdj-app-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript && document.currentScript.parentNode
    ? document.currentScript.parentNode.querySelector('[data-mdj-sb]')
    : null;
  // Fallback: in the Theme Editor / some contexts currentScript may be null.
  if (!root) {
    var all = document.querySelectorAll('[data-mdj-sb]');
    root = all.length ? all[all.length - 1] : null;
  }
  if (!root) {
    return;
  }

  var STORAGE_KEY = 'mdj-sb-dismissed';
  var threshold = parseInt(root.getAttribute('data-threshold'), 10);
  if (isNaN(threshold) || threshold < 0) {
    threshold = 300;
  }

  function isDismissed() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setDismissed() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* sessionStorage unavailable (private mode / blocked) — ignore. */
    }
  }

  // If already dismissed this session, keep it out of the layout entirely.
  if (isDismissed()) {
    root.classList.add('is-hidden');
    return;
  }

  function reveal() {
    if (!root.classList.contains('is-visible')) {
      root.classList.add('is-visible');
    }
  }

  function onScroll() {
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) >= threshold) {
      reveal();
      window.removeEventListener('scroll', onScroll);
    }
  }

  // If the page is already scrolled past the threshold on load, reveal now.
  if ((window.pageYOffset || document.documentElement.scrollTop || 0) >= threshold) {
    reveal();
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var closeBtn = root.querySelector('[data-mdj-sb-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      root.classList.add('is-hidden');
      root.classList.remove('is-visible');
      setDismissed();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdj-email-caption"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-mdj-ec]');
  if(!root){ return; }
  var reopen = document.querySelector('[data-mdj-ec-reopen]');
  var closeBtn = root.querySelector('[data-mdj-ec-close]');
  var success = !!root.querySelector('[data-mdj-ec-success]');
  var DONE = 'mdj_ec_done', UNTIL = 'mdj_ec_until', SEEN = 'mdj_ec_seen';
  var cachedBar = null;

  function barRect(){
    if(cachedBar && document.body.contains(cachedBar)){
      var cs = getComputedStyle(cachedBar);
      if(cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') >= 0.15){
        var rr = cachedBar.getBoundingClientRect();
        if(rr.height > 10){ return rr; }
      }
      cachedBar = null;
    }
    var all = document.body.getElementsByTagName('*'), bestR = null, bestEl = null;
    for(var i = 0; i < all.length; i++){
      var el = all[i];
      if(el === root || el === reopen || root.contains(el)){ continue; }
      var c = getComputedStyle(el);
      if(c.position !== 'fixed'){ continue; }
      if(c.display === 'none' || c.visibility === 'hidden' || parseFloat(c.opacity || '1') < 0.15){ continue; }
      var r = el.getBoundingClientRect();
      if(r.height < 12 || r.width < 140){ continue; }
      if(r.bottom > window.innerHeight - 90 && r.top > window.innerHeight * 0.5){
        if(!bestR || r.top < bestR.top){ bestR = r; bestEl = el; }
      }
    }
    cachedBar = bestEl;
    return bestR;
  }
  function lift(){
    var r = barRect();
    var px = 24;
    if(r){ px = Math.round(window.innerHeight - r.top + 14); }
    document.documentElement.style.setProperty('--mdj-ec-bottom', px + 'px');
  }
  function relift(){ lift(); [250, 800, 1800, 3000].forEach(function(t){ setTimeout(lift, t); }); }

  function openModal(){ root.classList.add('is-open'); if(reopen){ reopen.classList.remove('is-visible'); } relift(); }
  function showTab(){ if(reopen){ reopen.classList.add('is-visible'); relift(); } }
  function closeModal(){
    root.classList.remove('is-open');
    try{ localStorage.setItem(UNTIL, String(Date.now() + 1209600000)); }catch(e){}
    showTab();
  }

  if(closeBtn){ closeBtn.addEventListener('click', closeModal); }
  if(reopen){ reopen.addEventListener('click', openModal); }

  /* ---- AJAX submit: capture the email in place, no page reload ---------------
     Shopify's {% form 'customer' %} natively does a full-page POST. We intercept
     it and fetch instead, so the modal swaps to its success state without the
     jarring reload. On success Shopify 302-redirects to ?customer_posted=true,
     so res.redirected (or the param) is our success signal; anything else shows
     a retry message. The native submit stays intact as a no-JS fallback. */
  var ecForm = root.querySelector('form');
  var ecFields = root.querySelector('[data-mdj-ec-fields]');
  var ecOk = root.querySelector('[data-mdj-ec-ok]');
  var ecErr = root.querySelector('[data-mdj-ec-err]');
  var ecSubmit = root.querySelector('[data-mdj-ec-submit]');
  var ecEmail = root.querySelector('[data-mdj-ec-email]');

  function ecShowError(msg){ if(ecErr){ ecErr.textContent = msg; ecErr.removeAttribute('hidden'); } }
  function ecOnSuccess(){
    if(ecFields){ ecFields.setAttribute('hidden', ''); }
    if(ecOk){ ecOk.removeAttribute('hidden'); }
    try{ localStorage.setItem(DONE, '1'); }catch(e){}
    // Reliable lead signal — GA4's auto form_submit can miss navigating forms.
    try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'generate_lead', lead_source: 'email_capture_popup' }); }catch(e){}
    relift();
  }

  if(ecForm && ecFields && ecOk){
    ecForm.addEventListener('submit', function(e){
      e.preventDefault();
      if(ecEmail && !ecEmail.checkValidity()){ ecEmail.reportValidity(); return; }
      if(ecErr){ ecErr.setAttribute('hidden', ''); }
      if(ecSubmit){ ecSubmit.disabled = true; ecSubmit.setAttribute('aria-busy', 'true'); }

      var action = (ecForm.getAttribute('action') || '/contact').split('#')[0];
      fetch(action, { method: 'POST', body: new FormData(ecForm), headers: { 'Accept': 'text/html, application/json' } })
        .then(function(res){
          var ok = res.ok && (res.redirected || res.url.indexOf('customer_posted=true') > -1 || res.url.indexOf('contact_posted=true') > -1);
          if(ok){ ecOnSuccess(); }
          else { ecShowError('Sorry, that didn’t go through — check your email and try again.'); }
        })
        .catch(function(){ ecShowError('Network hiccup — please try again.'); })
        .then(function(){ if(ecSubmit){ ecSubmit.disabled = false; ecSubmit.removeAttribute('aria-busy'); } });
    });
  }

  var ticking = false;
  function reflow(){
    var active = root.classList.contains('is-open') || (reopen && reopen.classList.contains('is-visible'));
    if(!active || ticking){ return; }
    ticking = true;
    requestAnimationFrame(function(){ lift(); ticking = false; });
  }
  window.addEventListener('resize', reflow);
  window.addEventListener('scroll', reflow, { passive: true });

  if(success){
    try{ localStorage.setItem(DONE, '1'); }catch(e){}
    openModal();
    return;
  }

  var done = false, until = 0, seen = false;
  try{ done = localStorage.getItem(DONE) === '1'; until = parseInt(localStorage.getItem(UNTIL), 10) || 0; }catch(e){}
  try{ seen = sessionStorage.getItem(SEEN) === '1'; }catch(e){}
  if(done){ return; }

  if(!seen && Date.now() >= until){
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 3000;
    setTimeout(function(){
      try{ sessionStorage.setItem(SEEN, '1'); }catch(e){}
      openModal();
    }, delay);
  } else {
    showTab();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
